
import React from "react";
import Link from "next/link";
import Image from "next/image";

interface RelatedBlogsProps {
  blok?: any;
}

const RelatedResources: React.FC<RelatedBlogsProps> = ({ blok }) => {
  if (!blok) return null;

  const {
    title,
    slug,
  } = blok || {};

  const imageUrl = blok?.thumb?.filename || blok?.thumb || "";

  return (
    <div className="col">
      <Link
        href={slug}
        className="blog-preview card card-lighter scroll-trigger overflow-hidden d-flex flex-column h-100"
        target=""
      >
        <div className="blog-preview-image position-relative">
          <Image
            src={imageUrl || ""}
            alt={title || "Blog preview"}
            fill
            className="object-fit-cover"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            loading="lazy"
            quality={75}
          />
        </div>
        <div className="blog-preview-content p-3 p-lg-4 flex-grow-1 d-flex flex-column">
          <h3 className="h4 blog-preview-text mb-3">{title}</h3>
          <p className="blog-preview-link mt-auto mb-0">
            <span className="d-block btn btn-primary">Read More</span>
          </p>
        </div>
      </Link>
    </div>
  );
};

export default RelatedResources;